import React from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useWatch } from 'react-hook-form';

import { errorCodes } from '../../../constants/errorMessages';
import {
  PasswordPolicy,
  checkPasswordPolicy,
  getPasswordRuleText,
  passwordRuleCodes,
} from '../../../utilities/passwordPolicy';

const checklistRuleCodes = passwordRuleCodes.filter(
  (code) => code !== errorCodes.PASSWORD_TOO_LONG,
);

type PasswordPolicyChecklistProps = {
  source: string;
  policy: PasswordPolicy;
}

const PasswordPolicyChecklist = ({ source, policy }: PasswordPolicyChecklistProps) => {
  const password: string = useWatch({ name: source }) ?? '';
  const results = checkPasswordPolicy(password, policy);

  return (
    <List sx={{ padding: 2, marginBottom: 4 }} dense disablePadding aria-label="Password Policy">
      {checklistRuleCodes.map((code) => (
        <ListItem key={code} disableGutters>
          <ListItemIcon sx={{ minWidth: 32 }}>
            {results[code]
              ? <CheckCircleIcon fontSize="small" color="success" titleAccess="Met" />
              : <CancelIcon fontSize="small" color="error" titleAccess="Not met" />}
          </ListItemIcon>
          <ListItemText primary={getPasswordRuleText(code, policy)} />
        </ListItem>
      ))}
    </List>
  );
};

export default PasswordPolicyChecklist;
